import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { CustomCursor } from "./components/CustomCursor";
import { FloatingAiAssistant } from "./components/ui/glowing-ai-chat-assistant";
import { SplashScreen } from "./components/SplashScreen";
import { CookieConsent } from "./components/CookieConsent";
import { ScrollToTop } from "./components/ScrollToTop";

const Index = lazy(() => import("./pages/Index"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Portfolio = lazy(() => import("./pages/Portfolio"));
const PortfolioLP = lazy(() => import("./pages/PortfolioLP"));
const HandwerkerWebsites = lazy(() => import("./pages/HandwerkerWebsites"));
const HandwerkerWebsitesLP = lazy(() => import("./pages/HandwerkerWebsitesLP"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const AboutUsLP = lazy(() => import("./pages/AboutUsLP"));
const GoogleAdsHandwerker = lazy(() => import("./pages/GoogleAdsHandwerker"));
const Impressum = lazy(() => import("./pages/Impressum"));
const Datenschutz = lazy(() => import("./pages/Datenschutz"));
const Kontakt = lazy(() => import("./pages/Kontakt"));
const Kundenstimmen = lazy(() => import("./pages/Kundenstimmen"));
const Danke = lazy(() => import("./pages/Danke"));
const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <SplashScreen />
      <CustomCursor />
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div className="min-h-screen bg-background flex items-center justify-center"></div>}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio-lp" element={<PortfolioLP />} />
            <Route path="/handwerker-websites" element={<HandwerkerWebsites />} />
            <Route path="/handwerker-websites-lp" element={<HandwerkerWebsitesLP />} />
            <Route path="/ueber-uns" element={<AboutUs />} />
            <Route path="/ueber-uns-lp" element={<AboutUsLP />} />
            <Route path="/google-ads-fuer-handwerker" element={<GoogleAdsHandwerker />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/kundenstimmen" element={<Kundenstimmen />} />
            <Route path="/danke" element={<Danke />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <CookieConsent />
      </BrowserRouter>
      <FloatingAiAssistant />
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
